import { requestJson } from './requestJson';
import { buildApiUrl } from './apiUrl';

const USER_PASSWORDS_ENDPOINT = buildApiUrl('/api/user-passwords');

function authHeaders(accessToken) {
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

export async function generateUserPassword(
  accessToken,
  email,
  replaceExisting = false,
  siteUrl = '',
  expiresAt = '',
  locationLabel = '',
  locationStatusChanges = []
) {
  return requestJson(USER_PASSWORDS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({ email, replaceExisting, siteUrl, expiresAt, locationLabel, locationStatusChanges }),
  });
}

export async function fetchUserPasswordGenerationContext(accessToken, email) {
  return requestJson(USER_PASSWORDS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({ action: 'getGenerationContext', email }),
  });
}

export async function requestUserAccess(email, siteUrl = '') {
  return requestJson(USER_PASSWORDS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ action: 'requestAccess', email, siteUrl }),
  });
}

export async function fetchUserPasswordStatuses(accessToken, emails = []) {
  const normalizedEmails = Array.from(
    new Set(
      (Array.isArray(emails) ? emails : [])
        .map((value) => String(value || '').trim().toLowerCase())
        .filter(Boolean)
    )
  );

  return requestJson(USER_PASSWORDS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'getStatuses',
      emails: normalizedEmails,
    }),
  });
}

export async function fetchUserPasswordDetails(accessToken, email) {
  return requestJson(USER_PASSWORDS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'getPassword',
      email,
    }),
  });
}
